<template>
  <div class="bb-settings-categories">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
      <div class="bb-settings-categories-tabs">
        <template v-for="tab in tabsList">
          <div
            :key="tab.id"
            class="bb-settings-categories-tabs__item"
            :class="{'bb-settings-categories-tabs__item_active' : activeTab.id === tab.id}"
            @click="setActiveTab(tab)"
          >
            {{ tab.title }}
          </div>
        </template>
      </div>
    <div
      class="bb-settings-categories-content"
      :class="[activeTab.id === listOfProjectTabId && 'bb-settings-categories-content_project']"
    >
      <div class="bb-settings-categories-content-subtitle">
        <div class="bb-settings-categories-content-subtitle__text">
          {{activeTab.subTitle}}
        </div>
        <button
          v-if="activeTab.id === listOfProjectTabId"
          class="bb-button bb-settings-categories-content-subtitle__button"
          :disabled="isDisabled"
          @click="onAddHandler"
        >
          ADD
        </button>
      </div>
      <template v-if="activeTab.id !== listOfProjectTabId">
        <div class="bb-settings-categories-items">
          <div class="bb-settings-categories-items__item"
               v-for="(type, index) in activeTab.typeCategories"
               :key="index+type"
          >
            <subsection-list
              :placeholder="type"
              :list="filterByType(index + 1)"
              :type="index + 1"
              :sortOff="true"
              :isError.sync="isError"
              descriptionErrorPopup="This category has already been created"
              :hideEditButton="expenseFinanceTabId !== activeTab.id"
              @create="createCategories"
              @delete="deleteCategories"
              @edit="editCategories"/>
          </div>
        </div>
        <ExpenseCategoriesTimeoffLimits v-if="activeTab.id === expenseHrTabId" />
      </template>
      <ExpenseCategoriesListOfProject
        v-else
        ref="childComponent"
        :isDisabled.sync="isDisabled"
      />
    </div>
  </div>
</template>

<script>
import SubsectionList from '@/components/Settings/Services/SubsectionList/SubsectionList'
import ExpensesCategoryApi from '@/api/ExpenseCategories/api'
import HrAssetCategoriesApi from '@/api/HrAssetCategories/api'
import _ from 'lodash'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import {
  EXPENSE_CATEGORY_LIST_TABS,
  EXPENSE_FINANCE_TAB_ID,
  EXPENSE_HR_TAB_ID,
  LIST_OF_PROJECT_TAB_ID
} from '@/constants/Tabs/expenseListTabs'
import ExpenseCategoriesTimeoffLimits from '@/components/Settings/ExpenseCategories/ExpenseCategoriesTimeoffLimits'
import ExpenseCategoriesListOfProject
  from '@/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProject'

export default {
  name: 'SettingsExpenseCategories',
  components: {
    ExpenseCategoriesTimeoffLimits,
    SubsectionList,
    LoaderFly,
    ExpenseCategoriesListOfProject
  },
  data () {
    return {
      loaderRun: false,
      tabsList: EXPENSE_CATEGORY_LIST_TABS,
      expenseFinanceTabId: EXPENSE_FINANCE_TAB_ID,
      expenseHrTabId: EXPENSE_HR_TAB_ID,
      listOfProjectTabId: LIST_OF_PROJECT_TAB_ID,
      hrAssetCategories: [],
      activeTab: null,
      isError: false,
      isDisabled: false
    }
  },
  computed: {
    expenseCategories: {
      get: function () {
        return this.$store.getters.expenseCategories
      },
      set: function (data) {
        this.$store.dispatch('setExpensesCategories', data)
      }
    }
  },
  watch: {
    activeTab (val) {
      if (val.id === this.expenseHrTabId && !this.hrAssetCategories.length) {
        this.getAssetHrCategories()
      }
      this.isError = false
    }
  },
  methods: {
    setActiveTab (tab) {
      this.activeTab = tab
    },
    filterByType (type) {
      return this.activeTab.id === this.expenseFinanceTabId
        ? _.filter(this.expenseCategories, {type})
        : this.hrAssetCategories
    },
    getExpensesCategories () {
      this.loaderRun = true
      ExpensesCategoryApi.getExpenseCategories()
        .then((resp) => {
          this.loaderRun = false
          this.expenseCategories = resp.data.expensesCategories.reverse()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async getAssetHrCategories () {
      this.loaderRun = true
      try {
        const {data} = await HrAssetCategoriesApi.getAssetHrCategories({})
        const { hrassetcategories } = data
        hrassetcategories.forEach((el) => { el.id = el._id })
        this.hrAssetCategories = hrassetcategories
        this.loaderRun = false
      } catch (err) {
        console.error(err)
        this.loaderRun = false
      }
    },
    createCategories (category) {
      if (this.isError) return
      const nameApi = this.expenseFinanceTabId === this.activeTab.id
        ? ExpensesCategoryApi.createExpenseCategories(category)
        : HrAssetCategoriesApi.createAssetHrCategory(category)
      nameApi
        .then(({data}) => {
          category.name = ''
          this.expenseFinanceTabId === this.activeTab.id
            ? this.expenseCategories.unshift(data)
            : this.hrAssetCategories.unshift(data)
        })
        .catch((err) => {
          this.isError = true
          console.error(err)
        })
    },
    editCategories (item) {
      if (this.isError) return
      const index = (_.findIndex(this.expenseCategories, {id: item.id}))
      ExpensesCategoryApi.editExpenseCategories(item)
        .then((resp) => {
          this.expenseCategories.splice(index, 1, resp.data)
        })
        .catch((err) => {
          this.isError = true
          console.error(err)
        })
    },
    deleteCategories (index, id) {
      const trueIndex = (_.findIndex(this.expenseCategories, {id}))

      const nameApi = this.expenseFinanceTabId === this.activeTab.id
        ? ExpensesCategoryApi.deleteExpenseCategories(id)
        : HrAssetCategoriesApi.deleteAssetHrCategory(id)
      nameApi
        .then((resp) => {
          this.expenseFinanceTabId === this.activeTab.id
            ? this.expenseCategories.splice(trueIndex, 1)
            : this.hrAssetCategories = this.hrAssetCategories.filter((el) => el._id !== id)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    onAddHandler () {
      this.isDisabled = true
      this.$refs.childComponent.addNewType()
    }
  },
  beforeMount () {
    this.activeTab = this.tabsList.find((el) => el.id === this.expenseFinanceTabId)
    this.getExpensesCategories()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-settings-categories {
    margin: -10px -20px -10px -20px;

    &-tabs {
      display: flex;
      align-items: center;
      width: 100%;
      height: 54px;
      background: $color-white;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      margin: 0 0 6px 0;

      &__item {
        padding: 18px 26px 18px 26px;
        color: $color-accent;
        font-size: 15px;
        font-weight: 600;
        line-height: 18px;
        position: relative;
        cursor: pointer;

        & + & {
          margin: 0 0 0 32px;
        }

        &:after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
          border-radius: 3px 4px 0 0;
          background-color: $color-accent;
          transition: 0.3s;
          opacity: 0;
          height: 0;
        }

        &_active {
          pointer-events: none;

          &:after {
            opacity: 1;
            height: 3px;
          }
        }

        &:hover {
          &:after {
            background-color: $color-accent-hover;
            opacity: 1;
            height: 3px;
          }
        }
      }
    }

    &-content {
      height: calc(100vh - 120px);
      background: $color-white;
      padding: 24px 24px 24px 24px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      &_project {
        margin: -2px 0 0 0;
      }
    }

    &-items {
      @include global-font;
      display: flex;
      margin: 12px 0 12px 0;

      &__item {
        width: 100%;
        flex-grow: 1;
        max-width: 494px;

        & + & {
          margin: 0 0 0 25px;
        }
      }
    }
  }

  .bb-settings-categories-content-subtitle {
    display: flex;
    align-items: center;
    grid-gap: 0 15px;

    &__text {
      font-size: 25px;
      font-weight: 600;
      line-height: 30px;
      color: $color-accent;
    }

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 36px;
      width: 64px;
    }

  }
</style>

<style lang="scss">
@import "../../../sass/variables";
  .bb-settings-categories {

    .bb-subsection-list {
      height: 100% !important;
      max-height: 306px;
      margin-top: 20px !important;
      border-radius: 5px;
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
    }

    .bb-list {

      &-header {
        padding: 0;

        &__input {
          border: 1px solid $color-mercury;
        }
      }

      &-body {
       margin-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategory.vue